import { createContext } from 'react';

export interface ApplicantView {
  applicantId: string;
  email: string;
}

export interface ApplicantSessionState {
  applicant: ApplicantView | null;
  /** True until a stored session has been checked with the backend. */
  loading: boolean;
  /** Sends a code to the address. Resolves when the backend has accepted it. */
  requestCode: (email: string) => Promise<void>;
  signIn: (email: string, code: string) => Promise<void>;
  signOut: () => void;
}

export const ApplicantSessionContext = createContext<ApplicantSessionState | null>(null);
